<script>
    import {onMount} from 'svelte';

    import AuthService from "../services/auth.service";
    import TrashbinService from "../services/trashbin.service";
    import OrganizationsService from "../services/organizations.service";

    export let params, errorMessage;

    let deletedSections = [];
    let deletedTeams = [];
    let organizations = [];
    let selectedOrganization = null;
    let disableButton = null;

    onMount( async () => {
        organizations = await OrganizationsService.list();
        selectedOrganization = organizations[0];
        loadDeletedItems();
    });

    function deletedSection(itemId) {
        deletedSections = deletedSections.filter(item => item.id !== itemId);
    }

    function deletedTeam(itemId) {
        deletedTeams = deletedTeams.filter(item => item.id !== itemId);
    }

    async function loadDeletedItems() {
        if (!organizations[0]) return;

        deletedSections = [];
        deletedTeams = [];
        errorMessage = null;

        try {
            deletedSections = await TrashbinService.loadSections(selectedOrganization.id);
            deletedTeams = await TrashbinService.loadTeams(selectedOrganization.id);
        } catch (e) {
            console.log(e);
            errorMessage = e.message;
        }
    }

    async function restoreItem(itemId) {
        errorMessage = null;
        disableButton = itemId;

        try {
            await TrashbinService.restoreSection(selectedOrganization.id, itemId);
            await deletedSection(itemId);
        } catch (e) {
            errorMessage = e.message;
        }
    }

    async function restoreTeam(itemId) {
        errorMessage = null;

        try {
            await TrashbinService.restoreTeam(selectedOrganization.id, itemId);
            await deletedSection(itemId);
        } catch (e) {
            errorMessage = e.message;
        }
    }

    function change(organization) {
        selectedOrganization = organization;
        loadDeletedItems();
    }
</script>

<div id="pageDiv">
    <main class="pt-3 container">
        <div class="row">
            <div class="col">
                <h3>Trash Bin</h3>
                <p>
                    <a class="navbar-brand" href="/dashboard"><small><i class="fa fa-angle-left"></i> Back to the Dashboard</small></a>
                </p>
                <div class="row">
                    <div class="col-3">
                        {#if organizations.length > 0}
                            <div class="dropdown mb-2 btn-block">
                                <button class="btn btn-primary btn-block dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {selectedOrganization.name}
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    {#each organizations as organization}
                                        <label class="dropdown-item" on:click={ () => change(organization) }>
                                            {organization.name}
                                        </label>
                                    {/each}
                                </div>
                            </div>
                        {/if}
                    </div>
                    <div class="col-9">
                        <div class="alert alert-info">
                            Review these deleted items, and click the
                            <button class="btn btn-sm py-0 btn-outline-primary" disabled>
                                <i class="fa fa-undo"></i>
                            </button> RESTORE button to undelete the item.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                {#if AuthService.can('RESTORE_SECTION') }
                    <div class="card mb-2">
                        <div class="card-header">
                            <h5 class="card-title mb-0" id="addEmployeeLabel">Deleted Sections</h5>
                        </div>
                        <div class="card-body">
                            <table class="table table-md">
                                <tr class="font-weight-bold text-uppercase">
                                    <th><small>Section</small></th>
                                    <th class="text-center"><small>Deleted</small></th>
                                    <th class="text-right"><small>Restore</small></th>
                                </tr>
                                {#each deletedSections as section}
                                    <tr>
                                        <td class="p-1">
                                            <small><strong>
                                                {section.id} - {section.title}
                                            </strong></small>
                                        </td>
                                        <td class="text-center p-1">
                                            <small>{section.deleted_at.split('T')[0]}</small>
                                        </td>
                                        <td class="text-right p-1">
                                            <button class="btn btn-sm py-0 btn-outline-primary" on:click={restoreItem(section.id)} disabled={section.id === disableButton}>
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        </td>
                                    </tr>
                                {/each}
                            </table>
                        </div>
                        {#if errorMessage}
                            <div class="alert alert-danger">
                                ERROR: {errorMessage}
                            </div>
                        {/if}
                    </div>
                {/if}

                {#if AuthService.can('RESTORE_TEAM') }
                    <div class="card mb-2">
                        <div class="card-header">
                            <h5 class="card-title mb-0" id="addEmployeeLabel">Deleted Teams</h5>
                        </div>
                        <div class="card-body">
                            <table class="table table-md">
                                <tr class="font-weight-bold text-uppercase">
                                    <th><small>Team</small></th>
                                    <th class="text-center"><small>Deleted</small></th>
                                    <th class="text-right"><small>Restore</small></th>
                                </tr>
                                {#each deletedTeams as team}
                                    <tr>
                                        <td class="p-1">
                                            <small><strong>
                                                {team.id} - {team.title}
                                            </strong></small>
                                        </td>
                                        <td class="text-center p-1">
                                            <small>{team.deleted_at.split('T')[0]}</small>
                                        </td>
                                        <td class="text-right p-1">
                                            <button class="btn btn-sm py-0 btn-outline-primary" on:click={restoreTeam(team.id)} disabled={team.id === disableButton}>
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        </td>
                                    </tr>
                                {/each}
                            </table>
                        </div>
                        {#if errorMessage}
                            <div class="alert alert-danger">
                                ERROR: {errorMessage}
                            </div>
                        {/if}
                    </div>
                {/if}
            </div>
        </div>
    </main>
</div>
